<template>
	<app-content class="h-panel">
		<div class="h-panel-bar"><span class="h-panel-title">凭证列表</span></div>
		<div class="margin-right-left margin-top">
			<account-date-choose v-model="accountDate"/>
			<Button size="s" icon="h-icon-search" @click="openFilter">筛选</Button>
			<DropdownMenu v-if="savedFilters.length" button size="s" :datas="savedFilters" @click="applySavedFilter">常用筛选</DropdownMenu>
			<Button size="s" icon="h-icon-refresh" @click="loadList">刷新</Button>
			<div class="float-right">
				<template v-if="User.role!=='View' && currentAccountSets.voucherReviewed">
					<Button :loading="loading" @click="audit">审核</Button>
					<Button :loading="loading" @click="cancelAudit">取消审核</Button>
					<Button :loading="loading" color="red" @click="openBatchReject">批量驳回</Button>
				</template>
				<template v-if="User.role!=='View'">
					<Button :loading="loading" @click="mergeVoucher">合并凭证</Button>
					<Button :loading="loading" @click="batchDelete">批量删除</Button>
					<DropdownMenu button :loading="loading" @click="batchSign" :datas="signParam">批量签章</DropdownMenu>
				</template>
				<DropdownMenu button @click="trigger" :datas="param">打印</DropdownMenu>
				<DropdownMenu button @click="triggerExport" :datas="exportParam">导出</DropdownMenu>
				<DropdownMenu button @click="triggerBook" :datas="bookParam">电子账簿</DropdownMenu>
				<input ref="pdfFile" type="file" accept="application/pdf" style="display: none" @change="verifyFileChange($event)">
				<template v-if="User.role!=='View'">
					<Button :loading="loading" @click="openBreakNo">断号整理</Button>
					<Button :loading="loading" @click="openDustbin">回收站</Button>
					<Button :loading="loading" @click="doUpload">
					<input ref="file" type="file" accept="application/vnd.ms-excel" style="display: none" @change="fileChange($event)">
					导入凭证
				</Button>
				<Button @click="downloadTemplate">下载模板</Button>
					<Button color="primary" @click="$router.push({name:'VoucherForm'})">新增凭证</Button>
				</template>
			</div>
		</div>
		<div class="h-panel-body">
			<table class="header">
				<tr>
					<th style="width: 50px"><input :checked="checkAll" type="checkbox" @click="checkAll=!checkAll"></th>
					<td style="width: 215px">摘要</td>
					<td>科目</td>
					<td align="right" style="width: 130px">借方金额</td>
					<td align="right" style="width: 130px">贷方金额</td>
				</tr>
			</table>
			<table v-if="!datas.length">
				<tr>
					<td colspan="5" class="text-center padding">暂无数据</td>
				</tr>
			</table>
			<table class="details" v-for="data in datas" :key="data.id">
				<tr class="details-header">
					<th style="width: 50px"><input :class="{'display':data._checked}" v-model="data._checked" type="checkbox"></th>
					<td colspan="2">日期：{{data.voucherDate}} 凭证字号：{{data.word}}-{{data.code}}
					<span v-if="data.carryForward" class="tag">结转</span>
					<span v-if="data.hasBudgetEntry" class="tag" style="background:#b45f06;color:#fff;" v-tooltip content="含预算会计分录的平行记账凭证">平行</span>
					<span v-if="data.status === 1" class="tag" style="background:#f56c6c;color:#fff;">作废</span>
					<span v-if="data.draft === 1" class="tag" style="background:#e6a23c;color:#fff;">草稿</span>
					<span v-if="data.auditMemberId" class="tag" style="background:#19be6b;color:#fff;" v-tooltip="'审核人：' + (data.auditMemberName || '')">已审核</span>
					<span v-if="data.cashierSignId" class="tag" style="background:#2d8cf0;color:#fff;" v-tooltip="'出纳：' + (data.cashierSignName || '')">出纳签字</span>
					<span v-if="data.supervisorSignId" class="tag" style="background:#8e44ad;color:#fff;" v-tooltip="'主管：' + (data.supervisorSignName || '')">主管签章</span>
				</td>
					<td colspan="2" class="actions" align="right">
						<router-link v-if="data.auditMemberId" tag="span" :to="{name:'VoucherForm',params:{voucherId:data.id}}">查看</router-link>
						<a :href="`/api/pfd/voucher?id=${data.id}`" target="_blank">打印</a>
						<span @click="openAttachment(data)">附件<template v-if="attachmentCount(data.billList)">({{attachmentCount(data.billList)}})</template></span>
						<span @click="openLog(data)">日志</span>
						<span @click="openHistory(data)">历史</span>
						<router-link v-if="User.role!=='View' && data.status !== 1" tag="span" :to="{name:'VoucherForm',params:{voucherId:data.id}}">修改</router-link>
						<template v-if="User.role!=='View'">
							<span v-if="data.status !== 1" @click="copyVoucher(data)">复制</span>
							<span v-if="data.status !== 1" @click="redFlush(data)">红冲</span>
							<span v-if="!data.auditMemberId && !data.carryForward && data.status !== 1" @click="openSplit(data)">拆分</span>
							<span v-if="!data.auditMemberId && data.status !== 1" @click="insertVoucher(data)">插入</span>
							<span v-if="!data.auditMemberId" @click="remove(data)">删除</span>
							<span v-if="data.status !== 1 && !data.carryForward && data.draft !== 1" @click="doVoid(data)">作废</span>
							<span v-if="data.status === 1 && !data.auditMemberId" @click="doUnvoid(data)">反作废</span>
						</template>
						<i v-if="data.auditMemberId" class="h-icon-completed green-color" v-tooltip content="已审核"></i>
					</td>
				</tr>
				<tr v-for="d in data.details" :key="d.id">
					<th></th>
					<td style="width: 215px">
						{{d.summary}}
						<template v-if="d.subject&&d.num&&d.price">
							(数量:{{d.num}}<span class="dark4-color">{{d.subject.unit}}</span>，单价:{{d.price}}<span class="dark4-color">元</span>)
						</template>
					</td>
					<td>{{d.subjectName}}</td>
					<td align="right" style="width: 130px">{{d.debitAmount|numFormat}}</td>
					<td align="right" style="width: 130px">{{d.creditAmount|numFormat}}</td>
				</tr>
				<tr class="font-bold">
					<td></td>
					<td>合计</td>
					<td>{{data.debitAmount|dxMoney}}</td>
					<td align="right">{{data.debitAmount|numFormat}}</td>
					<td align="right">{{data.creditAmount|numFormat}}</td>
				</tr>
			</table>
			<table class="details" v-if="datas.length">
				<tr class="font-bold">
					<td style="width: 50px"></td>
					<td style="width: 215px">本页合计（{{listSummary.count}} 张，不含作废）</td>
					<td></td>
					<td align="right" style="width: 130px">{{listSummary.totalDebit|numFormat}}</td>
					<td align="right" style="width: 130px">{{listSummary.totalCredit|numFormat}}</td>
				</tr>
				<tr v-for="w in wordSummary" :key="w.word" class="word-summary">
					<td></td>
					<td>其中：{{w.word}}字（{{w.count}} 张）</td>
					<td></td>
					<td align="right">{{w.totalDebit|numFormat}}</td>
					<td align="right">{{w.totalCredit|numFormat}}</td>
				</tr>
			</table>
			<Pagination v-model="pagination" @change="currentChange" layout="total,sizes,pager,jumper" align="center"/>
		</div>

		<Modal v-model="showFilter" :closeOnMask="false">
			<div slot="header">筛选</div>
			<Form label-position="left" :label-width="80">
				<FormItem label="凭证字">
					<Select v-model="filter.word" :datas="voucherWords" keyName="word" titleName="word" placeholder="全部"/>
				</FormItem>
				<FormItem label="凭证号">
					<Row type="flex" :space-x="10">
						<Cell :flex="1"><NumberInput :min="1" v-model="filter.codeStart"/></Cell>
						<Cell>至</Cell>
						<Cell :flex="1"><NumberInput :min="1" v-model="filter.codeEnd"/></Cell>
					</Row>
				</FormItem>
				<FormItem label="摘要">
					<input type="text" class="h-input" v-model="filter.summary"/>
				</FormItem>
				<FormItem label="科目">
					<input type="text" class="h-input" v-model="filter.subject" placeholder="编码/名称"/>
				</FormItem>
				<FormItem label="制单人">
					<Select v-model="filter.createMember" :datas="users" keyName="id" titleName="realName" placeholder="全部"/>
				</FormItem>
				<FormItem label="审核状态">
				<Select v-model="filter.auditStatus" :datas="[{key:'',title:'全部'},{key:'true',title:'已审核'},{key:'false',title:'未审核'}]"/>
			</FormItem>
			<FormItem label="出纳签字">
				<Select v-model="filter.cashierSignStatus" :datas="[{key:'',title:'全部'},{key:'true',title:'已签字'},{key:'false',title:'未签字'}]"/>
			</FormItem>
			<FormItem label="主管签章">
				<Select v-model="filter.supervisorSignStatus" :datas="[{key:'',title:'全部'},{key:'true',title:'已签章'},{key:'false',title:'未签章'}]"/>
			</FormItem>
			<FormItem label="凭证状态">
				<Select v-model="filter.voucherStatus" :datas="[{key:'',title:'全部'},{key:'normal',title:'正常'},{key:'draft',title:'草稿'},{key:'void',title:'作废'}]"/>
			</FormItem>
				<FormItem label="金额">
					<Row type="flex" :space-x="10">
						<Cell :flex="1"><NumberInput :min="0" v-model="filter.amountStart"/></Cell>
						<Cell>至</Cell>
						<Cell :flex="1"><NumberInput :min="0" v-model="filter.amountEnd"/></Cell>
					</Row>
				</FormItem>
				<FormItem label="排序字段">
					<Select v-model="filter.sortField" :datas="[{key:'',title:'默认'},{key:'code',title:'凭证号'},{key:'voucherDate',title:'凭证日期'}]"/>
				</FormItem>
				<FormItem label="排序方式">
					<Select v-model="filter.sortOrder" :datas="[{key:'asc',title:'升序'},{key:'desc',title:'降序'}]"/>
				</FormItem>
			</Form>
			<div slot="footer" class="filter-footer">
				<input type="text" class="h-input" v-width="180" v-model="filterSaveName" placeholder="输入名称，保存当前筛选条件"/>
				<Button size="s" :disabled="!filterSaveName" @click="saveFilter">存为常用筛选</Button>
				<Button @click="resetFilter">重置</Button>
				<Button color="primary" @click="applyFilter">确定</Button>
			</div>
		</Modal>

		<Modal v-model="mergeModal.show" :closeOnMask="false">
			<div slot="header">合并凭证</div>
			<p>凭证合并后将无法恢复，已选择 <b>{{checkedCount}}</b> 条凭证，确认要合并凭证吗？</p>
			<div class="margin-top">
				<p><label><input type="radio" v-model="mergeModal.mergeType" :value="0"/> 不合并分录</label></p>
				<p><label><input type="radio" v-model="mergeModal.mergeType" :value="1"/> 合并分录</label></p>
				<p><label><input type="radio" v-model="mergeModal.mergeType" :value="2"/> 不合并分录（先借后贷）</label></p>
			</div>
			<div slot="footer">
				<Button @click="mergeModal.show = false">取消</Button>
				<Button color="primary" :loading="mergeModal.loading" @click="doMerge">合并</Button>
			</div>
		</Modal>

		<Modal v-model="breakNo.show" :closeOnMask="false">
			<div slot="header">整理断号</div>
			<p>整理期间：<b>{{date.year()}}年{{date.month() + 1}}期</b></p>
			<div class="margin-top">
				<p class="font-bold">重编方式：</p>
				<p><label><input type="radio" v-model="breakNo.mode" value="code"/> 按凭证号重新顺次编号</label></p>
				<p><label><input type="radio" v-model="breakNo.mode" value="date"/> 按凭证日期重新顺次编号</label></p>
			</div>
			<div class="margin-top">
				<p class="font-bold">检查结果：</p>
				<template v-if="breakNo.checked">
					<p v-if="!hasBreak" class="green-color">编号连续，无需整理</p>
					<p v-for="r in breakNo.result" :key="r.word" v-if="r.missing.length">凭证字【{{r.word}}】 缺号：{{r.missing.join('、')}}</p>
				</template>
				<p v-else class="dark4-color">请先点击"检查断号"</p>
			</div>
			<div slot="footer">
				<Button @click="breakNo.show = false">取消</Button>
				<Button :loading="breakNo.loading" @click="checkBreakNo">检查断号</Button>
				<Button color="primary" :loading="breakNo.loading" :disabled="breakNo.checked && !hasBreak" @click="doFinishingOffNo">整理断号</Button>
			</div>
		</Modal>
			<electronic-book v-model="showBook" :accountDate="accountDate"/>

			<Modal v-model="attachmentModal.show" :width="600" :closeOnMask="false">
				<div slot="header">凭证附件【{{attachmentModal.voucher.word}}-{{attachmentModal.voucher.code}}】</div>
				<table class="h-table attachment-table">
					<tr>
						<th>文件名</th>
						<th style="width: 90px">大小</th>
						<th style="width: 80px">上传人</th>
						<th style="width: 150px">上传时间</th>
						<th style="width: 60px">操作</th>
					</tr>
					<tr v-for="(a, index) in attachmentModal.list" :key="index">
					<td><span class="text-hover" @click="previewAttachment(attachmentModal.voucher.id, index, a.name)">{{a.name}}</span></td>
					<td>{{(a.size / 1024).toFixed(1)}} KB</td>
					<td>{{a.createMember}}</td>
					<td>{{formatTime(a.createTime)}}</td>
					<td><span v-if="User.role!=='View'" class="text-hover red-color" @click="removeAttachment(index)">删除</span></td>
				</tr>
				<tr v-if="!attachmentModal.list.length">
					<td colspan="5" class="text-center padding">暂无附件，点击右下角"上传附件"添加单据图片或 PDF</td>
				</tr>
			</table>
			<div class="dark4-color" style="margin-top: 8px;">共 {{attachmentModal.list.length}} 个附件，合计 {{attachmentTotalSize}} KB。图片附件点击可放大预览，PDF 将在新窗口打开</div>
			<div slot="footer">
				<Button @click="attachmentModal.show = false">关闭</Button>
				<Button v-if="User.role!=='View'" color="primary" :loading="attachmentModal.uploading" @click="uploadAttachment">上传附件
					<input ref="attachmentFile" type="file" accept=".jpg,.jpeg,.png,.gif,.pdf" style="display: none" @change="attachmentFileChange($event)">
				</Button>
			</div>
		</Modal>

			<Modal v-model="previewModal.show" :closeOnMask="true">
				<div slot="header">附件预览 - {{previewModal.name}}</div>
				<div class="text-center">
					<img :src="previewModal.src" style="max-width: 100%; max-height: 65vh;" :alt="previewModal.name"/>
				</div>
				<div slot="footer">
					<Button color="primary" @click="previewModal.show = false">关闭</Button>
				</div>
			</Modal>

			<Modal v-model="splitModal.show" :width="640" :closeOnMask="false">
				<div slot="header">拆分凭证【{{splitModal.voucher.word}}-{{splitModal.voucher.code}}】</div>
				<p class="dark4-color">勾选需要拆出到新凭证的分录，原凭证保留未勾选分录。新凭证自动取号，拆分后两张凭证可能不再借贷平衡，请自行调整。</p>
				<table class="h-table" style="margin-top: 10px;">
					<tr>
						<th style="width: 50px"></th>
						<th>摘要</th>
						<th>科目</th>
						<th style="width: 120px" align="right">借方金额</th>
						<th style="width: 120px" align="right">贷方金额</th>
					</tr>
					<tr v-for="d in splitModal.details" :key="d.id" class="text-hover" @click="d._checked = !d._checked">
						<td class="text-center"><input type="checkbox" v-model="d._checked" @click.stop></td>
						<td>{{d.summary}}</td>
						<td>{{d.subjectName}}</td>
						<td align="right">{{d.debitAmount|numFormat}}</td>
						<td align="right">{{d.creditAmount|numFormat}}</td>
					</tr>
				</table>
				<div slot="footer">
					<Button @click="splitModal.show = false">取消</Button>
					<Button color="primary" :loading="splitModal.loading" :disabled="!splitCheckedCount || splitCheckedCount === splitModal.details.length" @click="doSplit">拆分</Button>
				</div>
			</Modal>

			<Modal v-model="dustbinModal.show" :width="720" :closeOnMask="false">
				<div slot="header">凭证回收站</div>
				<table class="h-table">
					<tr>
						<th>凭证字号</th>
						<th style="width: 110px">凭证日期</th>
						<th style="width: 160px">删除时间</th>
						<th style="width: 90px">删除人</th>
						<th style="width: 140px">操作</th>
					</tr>
					<tr v-for="d in dustbinModal.datas" :key="d.id">
						<td>{{d.word}}-{{d.code}}</td>
						<td>{{formatDay(d.voucherDate)}}</td>
						<td>{{formatTime(d.deleteDate)}}</td>
						<td>{{d.deleteMemberName}}</td>
						<td>
							<span class="text-hover blue-color" @click="restoreDustbin(d)">恢复</span>
							<span class="text-hover red-color" style="margin-left: 10px;" @click="destroyDustbin(d)">彻底删除</span>
						</td>
					</tr>
					<tr v-if="!dustbinModal.datas.length">
						<td colspan="5" class="text-center padding">回收站为空，删除的凭证会自动移入回收站（附件保留）</td>
					</tr>
				</table>
				<div class="text-center margin-top">
					<Pagination v-model="dustbinModal.pagination" @change="loadDustbin" layout="pager" small align="center"/>
				</div>
				<div class="dark4-color" style="margin-top: 8px;">恢复时尽量沿用原凭证号，若号码已被占用则自动取最新号；彻底删除将连同附件一并清除，无法找回。</div>
				<div slot="footer">
					<Button v-if="dustbinModal.datas.length" :loading="dustbinModal.clearing" @click="clearDustbin">清空回收站</Button>
					<Button color="primary" @click="dustbinModal.show = false">关闭</Button>
				</div>
			</Modal>

			<Modal v-model="logModal.show" :width="640" :closeOnMask="false">
				<div slot="header">凭证操作日志【{{logModal.voucher.word}}-{{logModal.voucher.code}}】</div>
				<table class="h-table">
					<tr>
						<th style="width: 150px">操作时间</th>
						<th style="width: 80px">操作人</th>
						<th style="width: 110px">操作类型</th>
						<th>说明</th>
					</tr>
					<tr v-for="l in logModal.datas" :key="l.id">
						<td>{{formatTime(l.createDate)}}</td>
						<td>{{l.operatorName}}</td>
						<td>{{logOperation(l.operation)}}</td>
						<td>{{l.detail}}</td>
					</tr>
					<tr v-if="!logModal.datas.length">
						<td colspan="4" class="text-center padding">暂无日志</td>
					</tr>
				</table>
				<div class="text-center margin-top">
					<Pagination v-model="logModal.pagination" @change="loadLog" layout="pager" small align="center"/>
				</div>
				<div slot="footer">
					<Button color="primary" @click="logModal.show = false">关闭</Button>
				</div>
			</Modal>

			<Modal v-model="historyModal.show" :width="760">
				<div slot="header">凭证修改历史【{{historyModal.voucher.word}}-{{historyModal.voucher.code}}】</div>
				<div class="history-wrap">
					<div class="history-list">
						<div v-for="h in historyModal.datas" :key="h.id"
							:class="['history-item', {active: historyModal.currentId === h.id}]"
							@click="loadHistorySnapshot(h)">
							<div class="v">V{{h.version}}</div>
							<div class="meta">{{formatTime(h.createDate)}}</div>
							<div class="op">{{h.operatorName}}</div>
						</div>
						<div v-if="!historyModal.datas.length" class="empty">暂无历史版本</div>
					</div>
					<div class="history-detail">
						<table class="h-table" v-if="historyModal.snapshot">
							<tr>
								<th>摘要</th>
								<th>科目</th>
								<th align="right" style="width:110px">借方</th>
								<th align="right" style="width:110px">贷方</th>
							</tr>
							<tr v-for="(d,i) in historyModal.snapshot.details" :key="i">
								<td>{{d.summary}}</td>
								<td>{{d.subjectCode}}-{{d.subjectName}}</td>
								<td align="right">{{d.debitAmount || ''}}</td>
								<td align="right">{{d.creditAmount || ''}}</td>
							</tr>
						</table>
						<div v-else class="empty">请选择左侧版本查看</div>
					</div>
				</div>
				<div slot="footer">
					<Button @click="historyModal.show = false">关闭</Button>
					<Button color="error" :loading="loading" :disabled="!historyModal.currentId" @click="doHistoryRollback">回滚到此版本</Button>
				</div>
			</Modal>

			<Modal v-model="verifyResult.show" :width="640">
				<div slot="header">电子账簿防篡改核验</div>
				<div class="verify-banner">
					<p class="green-color font-bold" style="font-size:16px;"><i class="h-icon-completed"></i> 核验通过，文件未被篡改</p>
					<p class="dark4-color">该文件的哈希与系统存证一致，且带有数字签名</p>
				</div>
				<table class="verify-table">
					<tr><td class="label">文件名</td><td>{{verifyResult.record.fileName}}</td></tr>
					<tr><td class="label">账簿期间</td><td>{{verifyResult.record.periodStart}} 至 {{verifyResult.record.periodEnd}}</td></tr>
					<tr><td class="label">纸张版式</td><td>{{paperLabel(verifyResult.record.paper)}}</td></tr>
					<tr><td class="label">装订留白</td><td>{{bindModeLabel(verifyResult.record.bindMode)}}</td></tr>
					<tr><td class="label">页数</td><td>{{verifyResult.record.pageCount}} 页</td></tr>
					<tr><td class="label">凭证数</td><td>{{verifyResult.record.voucherCount}} 张</td></tr>
					<tr><td class="label">导出人</td><td>{{verifyResult.record.operatorName}}</td></tr>
					<tr><td class="label">导出时间</td><td>{{formatVerifyTime(verifyResult.record.createTime)}}</td></tr>
					<tr><td class="label">签名前哈希</td><td class="mono">{{verifyResult.record.sourceSha256}}</td></tr>
					<tr><td class="label">签名后哈希</td><td class="mono">{{verifyResult.record.signedSha256}}</td></tr>
					<tr><td class="label">证书指纹</td><td class="mono">{{verifyResult.record.certFingerprint}}</td></tr>
				</table>
				<div slot="footer">
					<Button color="primary" @click="verifyResult.show = false">关闭</Button>
				</div>
			</Modal>

			<Modal v-model="batchRejectModal.show" :closeOnMask="false" :width="420">
				<div slot="header">批量驳回</div>
				<p>将对所选 {{batchRejectModal.count}} 张凭证记录驳回原因，制单人修改后可重新提交审核。</p>
				<div class="margin-top">
					<textarea class="h-input" rows="3" style="width: 100%;" v-model="batchRejectModal.reason" placeholder="请填写驳回原因（必填）"></textarea>
				</div>
				<div slot="footer">
					<Button @click="batchRejectModal.show = false">取消</Button>
					<Button color="primary" :loading="loading" @click="doBatchReject">确认驳回</Button>
				</div>
			</Modal>
		</app-content>
</template>

<script>
	import Qs from "qs";
	import moment from 'moment'
	import {mapState} from 'vuex'
	import ElectronicBook from './ElectronicBook'

	const emptyFilter = () => ({
		word: '',
		codeStart: null,
		codeEnd: null,
		summary: '',
		subject: '',
		createMember: null,
		auditStatus: '',
		cashierSignStatus: '',
		supervisorSignStatus: '',
		voucherStatus: '',
		amountStart: null,
		amountEnd: null,
		sortField: '',
		sortOrder: 'asc'
	});

	export default {
		name: "Voucher",
		components: {ElectronicBook},
		data() {
			return {
				datas: [],
				accountDate: null,
				pagination: {
					page: 1,
					size: Number(localStorage.getItem('voucherPageSize')) || 20,
					total: 0
				},
				loading: false,
				checkAll: false,
				param: [{title: '打印全部', key: 'printAll'}, {title: '打印选中', key: 'printCheck'}, {title: '凭证封面', key: 'printCover'}, {title: '凭证汇总表', key: 'printSummaryTable'}],
				exportParam: [{title: '导出选中', key: 'exportCheck'}, {title: '导出所有', key: 'exportAll'}],
				bookParam: [{title: '打开电子账簿', key: 'openElectronicBook'}, {title: '电子账簿防篡改核验', key: 'verifyPdf'}],
				signParam: [
					{title: '批量出纳签字', key: 'cashier'},
					{title: '批量主管签章', key: 'supervisor'},
					{title: '批量取消出纳签字', key: 'cancelCashier'},
					{title: '批量取消主管签章', key: 'cancelSupervisor'}
				],
				historyModal: {show: false, voucher: {}, datas: [], currentId: null, snapshot: null},
				showBook: false,
				verifyResult: {show: false, record: {}},
				attachmentModal: {show: false, voucher: {}, list: [], uploading: false},
				previewModal: {show: false, name: '', src: ''},
				splitModal: {show: false, voucher: {}, details: [], loading: false},
				dustbinModal: {show: false, datas: [], clearing: false, pagination: {page: 1, total: 0}},
				logModal: {show: false, voucher: {}, datas: [], pagination: {page: 1, total: 0}},
				logOperationMap: {
					CREATE: '新增', UPDATE: '修改', DELETE: '删除', BATCH_DELETE: '批量删除',
					AUDIT: '审核', CANCEL_AUDIT: '取消审核', MERGE: '合并', INSERT_SPACE: '插入凭证',
					IMPORT: '导入', CARRY_FORWARD: '期末结转', CARRY_FORWARD_QUERY: '结转金额查询',
					SIGN_CASHIER: '出纳签字', CANCEL_CASHIER: '取消出纳签字',
					SIGN_SUPERVISOR: '主管签章', CANCEL_SUPERVISOR: '取消主管签章',
					ATTACHMENT_ADD: '上传附件', ATTACHMENT_DELETE: '删除附件',
					SPLIT: '拆分', DUSTBIN_RESTORE: '回收站恢复', DUSTBIN_DESTROY: '回收站销毁', DUSTBIN_CLEAR: '清空回收站',
				VOID: '作废', UNVOID: '反作废', REJECT: '审核驳回',
				DRAFT_SAVE: '保存草稿', HISTORY_ROLLBACK: '历史回滚', AUTO_TRANSFER: '自动转账'
				},
				showFilter: false,
				filter: emptyFilter(),
				appliedFilter: emptyFilter(),
				filterSaveName: '',
				savedFilters: [],
				users: [],
				voucherWords: [],
				mergeModal: {show: false, mergeType: 0, loading: false},
				breakNo: {show: false, mode: 'code', result: [], checked: false, loading: false},
				batchRejectModal: {show: false, reason: '', count: 0}
			};
		},
		watch: {
			checkAll(nval) {
				let data = Array.from(this.datas);
				data.forEach(val => val._checked = nval);
				this.datas = data;
			},
			accountDate() {
				this.pagination.page = 1;
				this.loadList();
			}
		},
		computed: {
			...mapState(['User', 'currentAccountSets']),
			date() {
				return moment(this.accountDate);
			},
			checkedCount() {
				return this.datas.filter(value => value._checked).length;
			},
			attachmentTotalSize() {
				let total = 0;
				this.attachmentModal.list.forEach(a => total += Number(a.size) || 0);
				return (total / 1024).toFixed(1);
			},
			splitCheckedCount() {
				return this.splitModal.details.filter(d => d._checked).length;
			},
			hasBreak() {
				return this.breakNo.result.some(r => r.missing && r.missing.length);
			},
			//本页凭证借贷合计（不含作废凭证）
			listSummary() {
				let totalDebit = 0, totalCredit = 0, count = 0;
				(this.datas || []).forEach(v => {
					if (v.status === 1) return;
					count++;
					(v.details || []).forEach(d => {
						totalDebit += Number(d.debitAmount || 0);
						totalCredit += Number(d.creditAmount || 0);
					});
				});
				return {count, totalDebit, totalCredit};
			},
			//本页按凭证字分组统计（不含作废凭证，多种凭证字时展示）
			wordSummary() {
				let map = {};
				(this.datas || []).forEach(v => {
					if (v.status === 1) return;
					let w = map[v.word] || (map[v.word] = {word: v.word, count: 0, totalDebit: 0, totalCredit: 0});
					w.count++;
					(v.details || []).forEach(d => {
						w.totalDebit += Number(d.debitAmount || 0);
						w.totalCredit += Number(d.creditAmount || 0);
					});
				});
				let list = Object.values(map);
				return list.length > 1 ? list : [];
			}
		},
		methods: {
			currentChange() {
				//记住每页条数，下次进入凭证列表沿用
				let size = Number(this.pagination.size) || 20;
				localStorage.setItem('voucherPageSize', size);
				this.loadList();
			},
			trigger(key) {
				this[key].call(this);
			},
			triggerExport(key) {
				this[key].call(this);
			},
			triggerBook(key) {
				this[key].call(this);
			},
			openElectronicBook() {
				this.showBook = true;
			},
			verifyPdf() {
				this.$refs.pdfFile.click();
			},
			verifyFileChange(e) {
				if (this.$refs.pdfFile.files.length) {
					let formData = new FormData();
					formData.append('file', this.$refs.pdfFile.files[0]);
					this.loading = true;
					this.$api.voucher.bookVerify(formData).then(({data: result}) => {
						if (result && result.success) {
							this.verifyResult.record = result.data || {};
							this.verifyResult.show = true;
						} else {
							this.$Message.error((result && result.msg) || "核验失败");
						}
					}).catch(err => {
						let data = err.response && err.response.data;
						this.$Message.error((data && data.msg) || "核验失败：文件已被篡改或不是本系统签发的电子账簿");
					}).finally(() => {
						this.loading = false;
					});
					this.$refs.pdfFile.value = "";
				}
			},
			paperLabel(key) {
				return ({invoice: '发票版 24×14cm', a4: 'A4整版', a4half: 'A4两版', a4wide: 'A4宽 21×12cm（横向）', a5: 'A5（横向）', b5: 'B5（横向）'})[key] || key || '';
			},
			bindModeLabel(key) {
				return ({duplex: '双面打印（留白左右交替）', simplex: '单面打印（留白统一左侧）', none: '不打印（仅存档）'})[key] || key || '';
			},
			formatVerifyTime(t) {
				return (t || '').replace('T', ' ').substring(0, 19);
			},
			printAll() {
				let param = Qs.stringify({year: this.date.year(), month: this.date.month() + 1}, {indices: false});
				window.open(`/api/pfd/voucher?${param}`);
			},
			printCheck() {
				let checked = this.datas.filter(value => value._checked);
				if (checked.length) {
					let param = Qs.stringify({id: checked.map(value => value.id)}, {indices: false});
					window.open(`/api/pfd/voucher?${param}`);
				} else {
					this.$Message("未选择记录");
				}
			},
			exportCheck() {
				let checked = this.datas.filter(value => value._checked);
				if (!checked.length) {
					this.$Message("未选择记录");
					return;
				}
				this.download({ids: checked.map(value => value.id)});
			},
			exportAll() {
				this.download({year: this.date.year(), month: this.date.month() + 1});
			},
			download(params) {
				this.loading = true;
				this.$api.voucher.download(params).then(res => {
					let blob = new Blob([res.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
					let a = document.createElement('a');
					a.href = URL.createObjectURL(blob);
					a.download = '凭证.xlsx';
					a.click();
					URL.revokeObjectURL(a.href);
				}).catch(() => {
					this.$Message.error("导出失败");
				}).finally(() => {
					this.loading = false;
				});
			},
			loadList() {
				let params = Object.assign({
					voucher_year: this.date.year(),
					voucher_month: this.date.month() + 1,
					page: this.pagination.page,
					size: this.pagination.size || 20
				}, this.appliedFilter);
				Object.keys(params).forEach(key => {
					if (params[key] === '' || params[key] === null || params[key] === undefined) {
						delete params[key];
					}
				});
				this.$api.voucher.list(params).then(({data}) => {
					this.datas = data.records;
					this.pagination = {
						page: data.current,
						size: data.size,
						total: data.total
					}
				})
			},
			remove(data) {
				this.$Confirm("确认删除?删除后将移入回收站，可随时恢复").then(() => {
					this.$api.voucher.delete(data.id).then(() => {
						this.loadList();
					})
				});
			},
			doVoid(data) {
				this.$Confirm(`确认作废凭证【${data.word}-${data.code}】?作废后凭证号保留但不参与报表计算，不可修改`).then(() => {
					this.loading = true;
					this.$api.voucher.voidVoucher({voucherId: data.id}).then(() => {
						this.$Message('已作废');
						this.loadList();
					}).finally(() => {
						this.loading = false;
					});
				});
			},
			doUnvoid(data) {
				this.$Confirm(`确认反作废凭证【${data.word}-${data.code}】?`).then(() => {
					this.loading = true;
					this.$api.voucher.unvoidVoucher({voucherId: data.id}).then(() => {
						this.$Message('已恢复为正常凭证');
						this.loadList();
					}).finally(() => {
						this.loading = false;
					});
				});
			},
			downloadTemplate() {
				window.open(this.$api.voucher.importTemplate());
			},
			batchSign(item) {
				let isCancel = item.key.indexOf('cancel') === 0;
				let type = isCancel ? (item.key === 'cancelCashier' ? 'cashier' : 'supervisor') : item.key;
				let label = type === 'cashier' ? '出纳签字' : '主管签章';
				let checked = this.datas.filter(v => v._checked && v.status !== 1 && v.draft !== 1);
				if (isCancel) {
					//取消签字/签章：仅处理已签的凭证
					checked = checked.filter(v => type === 'cashier' ? v.cashierSignId : v.supervisorSignId);
					if (!checked.length) {
						this.$Message(`所选凭证均无${label}，无需取消`);
						return;
					}
				} else {
					if (type === 'supervisor') {
						//主管签章要求凭证已审核
						checked = checked.filter(v => v.auditMemberId && !v.supervisorSignId);
						if (!checked.length) {
							this.$Message("请选择已审核且未签章的凭证");
							return;
						}
					} else {
						//跳过已签字的凭证
						checked = checked.filter(v => !v.cashierSignId);
					}
					if (!checked.length) {
						this.$Message("请选择正式且未作废的待签字凭证");
						return;
					}
				}
				this.$Confirm(`确认对 ${checked.length} 条凭证批量${isCancel ? '取消' : ''}${label}?`).then(() => {
					this.loading = true;
					this.$api.voucher.batchSign({
						voucherIds: checked.map(v => v.id),
						type: type,
						cancel: isCancel
					}).then(() => {
						this.$Message(`批量${isCancel ? '取消' : ''}${label}成功`);
						this.loadList();
					}).finally(() => {
						this.loading = false;
					});
				});
			},
			openHistory(data) {
				this.historyModal.voucher = data;
				this.historyModal.datas = [];
				this.historyModal.currentId = null;
				this.historyModal.snapshot = null;
				this.historyModal.show = true;
				this.$api.voucher.history.list(data.id).then(({data}) => {
					this.historyModal.datas = data || [];
				});
			},
			loadHistorySnapshot(h) {
				this.historyModal.currentId = h.id;
				this.$api.voucher.history.detail(h.id).then(({data}) => {
					this.historyModal.snapshot = data;
				});
			},
			doHistoryRollback() {
				if (!this.historyModal.currentId) return;
				this.$Confirm("确认回滚到该历史版本？回滚后凭证将变为未审核状态，需重新审核").then(() => {
					this.loading = true;
					this.$api.voucher.history.rollback(this.historyModal.currentId).then(() => {
						this.historyModal.show = false;
						this.$Message("已回滚");
						this.loadList();
					}).finally(() => {
						this.loading = false;
					});
				});
			},
			copyVoucher(data) {
				this.$Confirm("确认要复制吗?").then(() => {
					this.$api.voucher.load(data.id).then(({data: v}) => {
						this.$router.push({name: 'VoucherForm', params: {copyData: v}});
					});
				});
			},
			redFlush(data) {
				this.$Confirm("确认要红冲吗?").then(() => {
					this.$api.voucher.load(data.id).then(({data: v}) => {
						v.details.forEach(d => {
							if (d.debitAmount) {
								d.debitAmount = -d.debitAmount;
							}
							if (d.creditAmount) {
								d.creditAmount = -d.creditAmount;
							}
							d.summary = '红冲-' + (d.summary || '');
						});
						this.$router.push({name: 'VoucherForm', params: {copyData: v}});
					});
				});
			},
			insertVoucher(data) {
				this.$Confirm(`确认要在【${data.word}-${data.code}】处插入凭证吗?其后凭证号将顺次后移`).then(() => {
					this.loading = true;
					this.$api.voucher.insert({word: data.word, code: data.code, year: this.date.year(), month: this.date.month() + 1}).then(() => {
						this.$router.push({name: 'VoucherForm', params: {insertData: {word: data.word, code: data.code}}});
					}).finally(() => {
						this.loading = false;
					});
				});
			},
			mergeVoucher() {
				let checked = this.datas.filter(value => value._checked);
				if (checked.length < 2) {
					this.$Message("请至少勾选2条未审核且未结账的凭证");
					return;
				}
				this.mergeModal.show = true;
			},
			doMerge() {
				let checked = this.datas.filter(value => value._checked);
				this.mergeModal.loading = true;
				this.$api.voucher.merge({checked: checked.map(value => value.id), mergeType: this.mergeModal.mergeType}).then(() => {
					this.$Message("合并成功");
					this.mergeModal.show = false;
					this.loadList();
				}).finally(() => {
					this.mergeModal.loading = false;
				});
			},
			openBreakNo() {
				this.breakNo.show = true;
				this.breakNo.result = [];
				this.breakNo.checked = false;
				this.checkBreakNo();
			},
			checkBreakNo() {
				this.breakNo.loading = true;
				this.$api.voucher.checkBreakNo({year: this.date.year(), month: this.date.month() + 1}).then(({data}) => {
					this.breakNo.result = data || [];
					this.breakNo.checked = true;
				}).finally(() => {
					this.breakNo.loading = false;
				});
			},
			doFinishingOffNo() {
				this.breakNo.loading = true;
				this.$api.voucher.finishingOffNo({year: this.date.year(), month: this.date.month() + 1, mode: this.breakNo.mode}).then(() => {
					this.$Message("整理完成");
					this.breakNo.show = false;
					this.loadList();
				}).finally(() => {
					this.breakNo.loading = false;
				});
			},
			openFilter() {
				this.filter = Object.assign({}, this.appliedFilter);
				this.filterSaveName = '';
				this.showFilter = true;
				if (!this.users.length) {
					this.$api.setting.accountSets.users().then(({data}) => {
						this.users = data || [];
					});
				}
				if (!this.voucherWords.length) {
					this.$api.setting.voucherWord.list().then(({data}) => {
						this.voucherWords = data || [];
					});
				}
			},
			applyFilter() {
				this.appliedFilter = Object.assign({}, this.filter);
				this.showFilter = false;
				this.pagination.page = 1;
				this.loadList();
			},
			resetFilter() {
				this.filter = emptyFilter();
			},
			saveFilter() {
				let name = (this.filterSaveName || '').trim();
				if (!name) {
					return;
				}
				if (this.savedFilters.some(f => f.title === name)) {
					this.$Message("已存在同名筛选，请换个名称");
					return;
				}
				this.savedFilters.push({title: name, key: name, filter: Object.assign({}, this.filter)});
				localStorage.setItem('voucherSavedFilters', JSON.stringify(this.savedFilters));
				this.filterSaveName = '';
				this.$Message("已保存为常用筛选");
			},
			applySavedFilter(key) {
				let f = this.savedFilters.find(item => item.key === key);
				if (f) {
					this.appliedFilter = Object.assign(emptyFilter(), f.filter);
					this.pagination.page = 1;
					this.loadList();
				}
			},
			batchDelete() {
				let checked = this.datas.filter(value => value._checked);
				if (checked.length) {
					this.$Confirm(`确认删除选中的 ${checked.length} 张凭证?删除后将移入回收站，可随时恢复`).then(() => {
						this.loading = true;
						this.$api.voucher.batchDelete({checked: checked.map(value => value.id), year: this.date.year(), month: this.date.month() + 1}).then(() => {
							this.loadList();
						}).finally(() => {
							this.loading = false
						});
					});
				} else {
					this.$Message("没有可删除凭证");
				}
			},
			audit() {
				let checked = this.datas.filter(value => value._checked);
				if (checked.length) {
					this.$Confirm("亲，确认要审核" + checked.length + "条凭证吗?").then(() => {
						this.loading = true;
						this.$api.voucher.audit({checked: checked.map(value => value.id), year: this.date.year(), month: this.date.month() + 1}).then(() => {
							this.loadList();
							this.$Message("审核成功！");
						}).finally(() => {
							this.loading = false;
						});
					});
				} else {
					this.$Message("未选择记录");
				}
			},
			cancelAudit() {
				let checked = this.datas.filter(value => value._checked);
				if (checked.length) {
					this.$Confirm("亲，确认要取消审核" + checked.length + "条凭证吗?").then(() => {
						this.loading = true;
						this.$api.voucher.cancelAudit({checked: checked.map(value => value.id), year: this.date.year(), month: this.date.month() + 1}).then(() => {
							this.loadList();
							this.$Message("取消审核成功！");
						}).finally(() => {
							this.loading = false;
						});
					});
				} else {
					this.$Message("未选择记录");
				}
			},
			openBatchReject() {
				let checked = this.datas.filter(value => value._checked);
				if (!checked.length) {
					this.$Message("未选择记录");
					return;
				}
				this.batchRejectModal.count = checked.length;
				this.batchRejectModal.reason = '';
				this.batchRejectModal.show = true;
			},
			doBatchReject() {
				let reason = (this.batchRejectModal.reason || '').trim();
				if (!reason) {
					this.$Message('请填写驳回原因');
					return;
				}
				let checked = this.datas.filter(value => value._checked);
				this.loading = true;
				this.$api.voucher.batchReject({checked: checked.map(value => value.id), year: this.date.year(), month: this.date.month() + 1, reason}).then(() => {
					this.batchRejectModal.show = false;
					this.loadList();
					this.$Message("已驳回，等待制单人修改");
				}).finally(() => {
					this.loading = false;
				});
			},
			parseBill(billList) {
				if (!billList) return [];
				try {
					return JSON.parse(billList) || [];
				} catch (e) {
					return [];
				}
			},
			attachmentCount(billList) {
				return this.parseBill(billList).length;
			},
			openAttachment(data) {
				this.attachmentModal.voucher = data;
				this.attachmentModal.list = this.parseBill(data.billList);
				this.attachmentModal.show = true;
			},
			uploadAttachment() {
				this.$refs.attachmentFile.click();
			},
			attachmentFileChange(e) {
				let file = e.target.files[0];
				if (!file) return;
				if (file.size > 10 * 1024 * 1024) {
					this.$Message.error('附件大小不能超过10MB');
					e.target.value = '';
					return;
				}
				let formData = new FormData();
				formData.append('file', file);
				this.attachmentModal.uploading = true;
				this.$api.voucher.uploadAttachment(this.attachmentModal.voucher.id, formData).then(({data}) => {
					this.attachmentModal.list = data || [];
					this.attachmentModal.voucher.billList = JSON.stringify(data || []);
					this.$Message('上传成功');
				}).finally(() => {
					this.attachmentModal.uploading = false;
					e.target.value = '';
				});
			},
			removeAttachment(index) {
				this.$Confirm('确认删除该附件?').then(() => {
					this.$api.voucher.deleteAttachment(this.attachmentModal.voucher.id, index).then(({data}) => {
						this.attachmentModal.list = data || [];
						this.attachmentModal.voucher.billList = JSON.stringify(data || []);
						this.$Message('删除成功');
					});
				});
			},
			isImage(name) {
				return /\.(jpg|jpeg|png|gif)$/i.test(name || '');
			},
			previewAttachment(voucherId, index, name) {
				if (this.isImage(name)) {
					this.previewModal.name = name || '';
					this.previewModal.src = this.$api.voucher.attachmentUrl(voucherId, index);
					this.previewModal.show = true;
				} else {
					window.open(this.$api.voucher.attachmentUrl(voucherId, index), '_blank');
				}
			},
			openSplit(data) {
				this.splitModal.voucher = data;
				this.splitModal.details = (data.details || []).map(d => Object.assign({_checked: false}, d));
				this.splitModal.show = true;
			},
			doSplit() {
				let detailIds = this.splitModal.details.filter(d => d._checked).map(d => d.id);
				if (!detailIds.length) {
					this.$Message("请选择要拆出的分录");
					return;
				}
				if (detailIds.length === this.splitModal.details.length) {
					this.$Message("原凭证至少需要保留一条分录");
					return;
				}
				this.$Confirm("拆分后新凭证将自动取号，且可能不再借贷平衡，确认拆分吗?").then(() => {
					this.splitModal.loading = true;
					this.$api.voucher.split({voucherId: this.splitModal.voucher.id, detailIds}).then(({data}) => {
						this.$Message(`拆分成功，新凭证为【${data.word}-${data.code}】`);
						this.splitModal.show = false;
						this.loadList();
					}).finally(() => {
						this.splitModal.loading = false;
					});
				});
			},
			openDustbin() {
				this.dustbinModal.show = true;
				this.dustbinModal.pagination.page = 1;
				this.loadDustbin();
			},
			loadDustbin() {
				this.$api.voucher.dustbin({page: this.dustbinModal.pagination.page, size: 10}).then(({data}) => {
					this.dustbinModal.datas = data.records || [];
					this.dustbinModal.pagination.total = data.total;
				});
			},
			restoreDustbin(d) {
				this.$Confirm(`确认恢复凭证【${d.word}-${d.code}】吗?恢复后将按当前最大号重新编号`).then(() => {
					this.$api.voucher.dustbinRestore({ids: [d.id]}).then(() => {
						this.$Message('恢复成功');
						this.loadDustbin();
						this.loadList();
					});
				});
			},
			destroyDustbin(d) {
				this.$Confirm(`彻底删除后凭证及附件将无法找回，确认删除【${d.word}-${d.code}】吗?`).then(() => {
					this.$api.voucher.dustbinDestroy({ids: [d.id]}).then(() => {
						this.$Message('已彻底删除');
						this.loadDustbin();
					});
				});
			},
			clearDustbin() {
				this.$Confirm('确认清空回收站吗?回收站内所有凭证及附件将无法找回！').then(() => {
					this.dustbinModal.clearing = true;
					this.$api.voucher.dustbinClear().then(() => {
						this.$Message('回收站已清空');
						this.loadDustbin();
					}).finally(() => {
						this.dustbinModal.clearing = false;
					});
				});
			},
			formatDay(t) {
				return t ? moment(t).format('YYYY-MM-DD') : '';
			},
			formatTime(t) {
				return t ? moment(t).format('YYYY-MM-DD HH:mm:ss') : '';
			},
			openLog(data) {
				this.logModal.voucher = data;
				this.logModal.pagination.page = 1;
				this.logModal.show = true;
				this.loadLog();
			},
			loadLog() {
				this.$api.voucher.log({voucherId: this.logModal.voucher.id, page: this.logModal.pagination.page, size: 10}).then(({data}) => {
					this.logModal.datas = data.records || [];
					this.logModal.pagination.total = data.total;
				});
			},
			logOperation(v) {
				return this.logOperationMap[v] || v;
			},
			escapeHtml(s) {
				return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
			},
			openPrintWindow(title, bodyHtml) {
				let win = window.open('', '_blank');
				if (!win) {
					this.$Message.error('浏览器拦截了打印窗口，请允许弹出窗口后重试');
					return;
				}
				win.document.write(`<!DOCTYPE html><html><head><meta charset="utf-8"><title>${title}</title><style>
					body {font-family: "SimSun","Microsoft YaHei",serif; margin: 40px; color: #000;}
					h2 {text-align: center; margin: 0 0 6px; letter-spacing: 4px;}
					.sub {text-align: center; margin-bottom: 18px; font-size: 13px;}
					table {width: 100%; border-collapse: collapse; font-size: 13px;}
					th, td {border: 1px solid #000; padding: 6px 8px;}
					th {background: #f0f0f0;}
					.center {text-align: center;}
					.right {text-align: right;}
					.info {margin: 10px 0; font-size: 13px;}
					.noprint {text-align: center; margin: 20px;}
					@media print {.noprint {display: none;}}
				</style></head><body>${bodyHtml}
				<div class="noprint"><button onclick="window.print()" style="padding:6px 24px;cursor:pointer;">打 印</button></div>
				<script>window.onload = function() { setTimeout(function() { window.print(); }, 300); };<\/script>
				</body></html>`);
				win.document.close();
			},
			printCover() {
				this.$api.voucher.cover({year: this.date.year(), month: this.date.month() + 1}).then(({data}) => {
					let rows = (data.words || []).map(w =>
						`<tr><td class="center">${this.escapeHtml(w.word)}</td><td>${this.escapeHtml(w.startCode)} 号 至 ${this.escapeHtml(w.endCode)} 号</td><td class="center">${this.escapeHtml(w.count)}</td></tr>`).join('');
					let body = `
						<h2>记 账 凭 证 封 面</h2>
						<div class="sub">${this.escapeHtml(data.year)} 年 ${this.escapeHtml(data.month)} 月</div>
						<div class="info">单位名称：${this.escapeHtml(data.companyName)}</div>
						<table>
							<tr><th style="width:130px">凭证字</th><th>起止号码</th><th style="width:130px">张数</th></tr>
							${rows || '<tr><td colspan="3" class="center">本期无凭证</td></tr>'}
							<tr><td class="center">合计</td><td colspan="2">共 ${this.escapeHtml(data.count)} 张，附单据 ${this.escapeHtml(data.receiptNum)} 张</td></tr>
						</table>
						<div class="info">借方合计：${(data.totalDebit || 0).toFixed(2)} 元（大写：${this.$options.filters.dxMoney(data.totalDebit || 0)}）</div>
						<div class="info">贷方合计：${(data.totalCredit || 0).toFixed(2)} 元（大写：${this.$options.filters.dxMoney(data.totalCredit || 0)}）</div>
						<div class="info">装订操作人：${this.escapeHtml(data.operator)}</div>`;
					this.openPrintWindow('凭证封面', body);
				});
			},
			printSummaryTable() {
				this.$api.voucher.summaryTable({year: this.date.year(), month: this.date.month() + 1}).then(({data}) => {
					let list = data || [];
					let totalDebit = 0, totalCredit = 0;
					let rows = list.map(r => {
						let debit = Number(r.debitAmount) || 0;
						let credit = Number(r.creditAmount) || 0;
						totalDebit += debit;
						totalCredit += credit;
						return `<tr><td class="center">${this.escapeHtml(r.subjectCode)}</td><td>${this.escapeHtml(r.subjectName)}</td>
							<td class="right">${debit.toFixed(2)}</td><td class="right">${credit.toFixed(2)}</td></tr>`;
					}).join('');
					let body = `
						<h2>记 账 凭 证 汇 总 表</h2>
						<div class="sub">${this.date.year()} 年 ${this.date.month() + 1} 月</div>
						<table>
							<tr><th style="width:130px">科目编码</th><th>科目名称</th><th style="width:150px">借方发生额</th><th style="width:150px">贷方发生额</th></tr>
							${rows || '<tr><td colspan="4" class="center">本期无数据</td></tr>'}
							<tr><td colspan="2" class="center">合计</td><td class="right">${totalDebit.toFixed(2)}</td><td class="right">${totalCredit.toFixed(2)}</td></tr>
						</table>
						<div class="info">借方合计（大写）：${this.$options.filters.dxMoney(totalDebit)}</div>
						<div class="info">贷方合计（大写）：${this.$options.filters.dxMoney(totalCredit)}</div>`;
					this.openPrintWindow('凭证汇总表', body);
				});
			},
			doUpload() {
				this.$refs.file.click();
			},
			fileChange(e) {
				if (this.$refs.file.files.length) {
					let formData = new FormData();
					formData.append('file', this.$refs.file.files[0]);
					this.loading = true;
					this.$api.voucher.import(formData).then(({data}) => {
						if (data) {
							this.accountDate = data;
						}
						this.$store.dispatch('init');
						this.$Message("亲,导入成功~");
					}).finally(() => {
						this.loading = false;
					});

					this.$refs.file.value = "";
				}
			}
		},
		mounted() {
			try {
				this.savedFilters = JSON.parse(localStorage.getItem('voucherSavedFilters') || '[]');
			} catch (e) {
				this.savedFilters = [];
			}
		}
	};
</script>
<style lang='less' scoped>
	.h-panel-body {
		table {
			width: 100%;
			border-collapse: collapse;

			td {
				padding: 7px;
			}

			&.header {
				background-color: @primary-color;
				color: white;
			}
		}

		.details {
			font-size: 12px;
			margin: 15px 0;
			border: 1px solid @gray2-color;

			.tag {
				background: @primary-color;
				color: #fff;
				padding: 0 6px;
				border-radius: 2px;
				font-size: 12px;
			}

			.actions {
				text-align: right;
				padding-right: 20px;

				span, a {
					display: none;
					margin-left: 8px;
					cursor: pointer;
				}
			}

			input {
				display: none;

				&.display {
					display: inline-block;
				}
			}

			&-header {
				background-color: @gray3-color;
				color: @dark3-color;
			}

			td, th {
				border-bottom: 1px solid @gray2-color;
			}

			tr:hover:not(.details-header) {
				background-color: #dff7df;
				cursor: pointer;
			}

			.word-summary {
				color: @dark4-color;

				&:hover {
					background-color: transparent;
					cursor: default;
				}
			}

			&:hover {
				box-shadow: 0 0 10px 0 #dadada;
				border-color: #dadada;

				.actions {
					span, a {
						display: inline-block;
					}
				}

				input {
					display: inline-block;
				}
			}
		}
	}

	.filter-footer {
			display: flex;
			align-items: center;
			gap: 8px;
		}

		.verify-banner {
			text-align: center;
			padding: 10px 0 16px;
			border-bottom: 1px solid @gray2-color;
			margin-bottom: 12px;
		}

		.verify-table {
			width: 100%;
			border-collapse: collapse;
			font-size: 13px;

			td {
				padding: 6px 8px;
				border-bottom: 1px solid @gray3-color;
				word-break: break-all;

				&.label {
					width: 90px;
					color: @dark4-color;
					white-space: nowrap;
				}

				&.mono {
				font-family: Consolas, Monaco, monospace;
				font-size: 12px;
			}
		}
	}

	.history-wrap {
		display: flex;
		border: 1px solid @border-color;
		min-height: 320px;
		max-height: 420px;

		.history-list {
			width: 150px;
			border-right: 1px solid @border-color;
			overflow-y: auto;
			flex-shrink: 0;

			.history-item {
				padding: 8px 10px;
				cursor: pointer;
				border-bottom: 1px solid @border-color;

				.v {
					font-weight: bold;
				}

				.meta, .op {
					font-size: 12px;
					color: @dark4-color;
				}

				&.active, &:hover {
					background: @primary-color;
					color: #fff;

					.meta, .op {
						color: #eee;
					}
				}
			}

			.empty {
				padding: 15px;
				color: @dark4-color;
				text-align: center;
			}
		}

		.history-detail {
			flex: 1;
			overflow-y: auto;
			padding: 8px;

			.empty {
				color: @dark4-color;
				text-align: center;
				padding-top: 120px;
			}
		}
	}
	</style>
